import React, { useState ,useEffect,useReducer,useRef} from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../../Common/Header';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";   
import CommonAPI from '../../Common/CommonAPI';
import SimpleReactValidator from 'simple-react-validator';
import moment from 'moment';
import axios from 'axios';
import SuccessMSG from "../../Common/SuccessMsg"
import DownloadPDF from "../../Common/DownloadPDF"
import FadeLoader from "react-spinners/HashLoader";

var api = require('../../Common/Config');
var  OWN_ACCOUNT_TRANSFER = 'api/transferMoneyOwnAccount';

function OwnTransfer(props) {    
    const [validator,setValidator] = useState(new SimpleReactValidator());
    const [showCalender, setCalender] = useState(false);
    const [FromAccountList, setFromAccountList] = useState([]);
    const [ToAccountList, setToAccountList] = useState([]);
    const [SelectFromAccount, setSelectFromAccount] = useState();
    const [SelectFromAccountID, setSelectFromAccountID] = useState();
    const [FromAccountAvailableBalance, setFromAccountAvailableBalance] = useState();
    const [EnteredAmount,setEnteredAmount] = useState();
    const [YourRef,setYourRef] = useState();
    const [BeneRef,setBeneRef] = useState();
    const [SelectDate,setSelectDate] = useState(new Date());
    const [SelectToAccount,setSelectToAccount] = useState();
    const [SelectToAccountID,setSelectToAccountID] = useState();
    const [HolderName,setHolderName] = useState();
    const [SavAccId,setSavAccId] = useState();
    const [ConfirmReview,setConfirmReview] = useState(false);
    const [TransActionRef,setTransActionRef] = useState();
    const [SuccessLoading,setSuccessLoading] = useState(false);
    const [RejectReview,setRejectReview] = useState(false);
    const [ShowReview,setShowReview] = useState(false);
    const [SelectToAll,setSelectToAll] =useState({});
    const [SelectFromAll,setSelectFromAll] =useState({});
    const [ErrorMsg,setErrorMsg] =useState("");
    const [ShowMain,setShowMain] =useState(true);
    const [ PdfDownload,setPdfDownload] =useState(false);
    const [toDate,settoDate] =useState(new Date());
    const [btnDisable,setbtnDisable] = useState(false);
    const [btnDisable2,setbtnDisable2] = useState(false);


    const ResponseLoadingModal = () => {
      return(
          <Modal
          size="lg"
          centered 
          className="ui-block" show={SuccessLoading}>          
                <FadeLoader
                height={25}
                width={5}
                radius={2}
                margin={2}
                color={"#197b55"}
                size={"80px"} this also works
                loading={SuccessLoading}
              />
         
         </Modal>
       )
    }
   
    const formRef = useRef(null);

    const [, forceUpdate] = useReducer(x => x + 1, 0);
    
    const GetAccountsAPI = () =>{
      CommonAPI.FromToAccountAPI((results) =>{   
          if( results){                    
            setFromAccountList(results.data.mapAccountList?results.data.mapAccountList.filter(e=>(e.fromOrToAccount==1 && e.showByAccOpt)):null);
            setToAccountList(results.data.mapAccountList?results.data.mapAccountList:null);                     
          }
      });
    }  
    
    useEffect( () => {    
    GetAccountsAPI();
    },[])  ;

    const SelectFromOnChange = (event) => {
        var passValFrom = JSON.parse(event.target.value);
        setSelectFromAll(JSON.parse(event.target.value));
        setSelectFromAccount(passValFrom.accountNo?passValFrom.accountNo:null);
        setSelectFromAccountID(passValFrom.id?passValFrom.id:null);
        setFromAccountAvailableBalance(passValFrom.avialableBalance?passValFrom.avialableBalance:null);         
     }

    const SelectToOnChange = (event) => {
        var passValTo = JSON.parse(event.target.value);
        
        setSelectToAll(JSON.parse(event.target.value));
        setSelectToAccount(passValTo.accountNo);
        setSelectToAccountID(passValTo.id);
        setHolderName(passValTo.holderName);
        setSavAccId(passValTo.savAccId);        
      }

    const OwnTransferConfirm = async ()=> {
       setSuccessLoading(true);

        var FormatedDate = '';    
        if(showCalender){
          FormatedDate = moment(SelectDate).format('DD/MM/YYYY')
        }else{
          FormatedDate = moment(new Date()).format('DD/MM/YYYY')
        }
        var forBody = {
              "fromAccountId": SelectFromAccountID,
              "toAccountId": SelectToAccountID,
              "amount": EnteredAmount,
              "yourReference": YourRef,
              "benefReference": BeneRef,
              "date": FormatedDate,
              "deviceType": "WEB"
        }
    
        return await axios({         
            method: "POST",
            url:api.HOST+OWN_ACCOUNT_TRANSFER,
            headers: {
              'Authorization' : `bearer ${JSON.parse(sessionStorage.getItem("tokenData")).accesstoken}`,
              'Content-Type': 'application/json'
            },
            data:JSON.stringify(forBody)
          })
          .then((result) => {
                  result.data.map((listVallue,index)=>{
                    if (listVallue.message==="SUCCESS"){
                        setbtnDisable(false) ;                    
                        setConfirmReview(true);
                        setTransActionRef(listVallue.otherInformation.refNumber);
                        setSuccessLoading(false);
                        setShowReview(false);                      
                        setShowMain(false);                      
                    }else {
                        setbtnDisable(false);                      
                        setRejectReview(true);
                        setSuccessLoading(false) ;                     
                    }
                  });
                  return result;
                }
          ).catch((error)=> {
            setbtnDisable(false) ;
            console.log(error);
        });        
      }

      const ValidateFields = () =>{
        var FormatedDate = '';    
        if(showCalender){
          FormatedDate = moment(SelectDate).format('DD/MM/YYYY')
        }else{
          FormatedDate = moment(new Date()).format('DD/MM/YYYY')
        }
        if (!validator.allValid()) {
            validator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`            
               forceUpdate();    
          }else if( SelectFromAccountID===SelectToAccountID){
            setErrorMsg("Select Different Account Number")
          }else if( EnteredAmount <= 0){
            setErrorMsg("Amount must be greater than 0")
          }else if((FormatedDate == moment(new Date()).format('DD/MM/YYYY')) && EnteredAmount>=(FromAccountAvailableBalance)){
            setErrorMsg("Insufficient balance")
          }else{
            setErrorMsg("")
            setShowReview(true);
          }
      }

      const ReviewModal = ()=>{
        
       return (
            <Modal
              show={ShowReview}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered 
              backdrop="static"
              onHide = {()=>setShowReview(false)}
            >
              <Modal.Header closeButton>
                <Modal.Title  id="contained-modal-title-vcenter">
                  <p className='modal-head-f'>TRANSFER</p><br/>REVIEW
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                
                <Form >
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5} xs={5}>
                            From
                        </Form.Label>
                        <Col sm={7} xs={7}>
                        <Form.Label className="c-font" column >
                            {SelectFromAccount}
                        </Form.Label>                        
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5} xs={5}>
                            To
                        </Form.Label>
                        <Col sm={7} xs={7}>
                        <Form.Label className="c-font" column>
                            {SelectToAccount}
                        </Form.Label>  
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5} xs={5}>
                            Amount
                        </Form.Label>
                        <Col sm={7} xs={7}>
                        <Form.Label className="c-font" column>
                            {parseFloat(EnteredAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                        </Form.Label>                        
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5} xs={5}>
                         Your Reference
                        </Form.Label>
                        <Col sm={7} xs={7}>
                        <Form.Label className="c-font" column>
                            {YourRef}
                        </Form.Label>                        
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5} xs={5}>
                         Beneficiary Reference
                        </Form.Label>
                        <Col sm={7} xs={7}>
                        <Form.Label className="c-font" column >
                            {BeneRef}
                        </Form.Label>                        
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5} xs={5}>
                         Payment Date
                        </Form.Label>
                        <Col sm={7} xs={7}>
                        <Form.Label className="c-font" column >
                            {showCalender?
                             moment(SelectDate).format('DD/MM/YYYY')
                            :moment(new Date()).format('DD/MM/YYYY')
                             }
                        </Form.Label>                        
                        </Col>
                    </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>                
                <Button className="btn-logout" 
                disabled={btnDisable}
                onClick={()=>{setbtnDisable(true);OwnTransferConfirm()}}>
                  Process Transfer
                  </Button>
              </Modal.Footer>
            </Modal>
          );         
      }

      const resetForm = () =>{
        
        setEnteredAmount(0);
        setBeneRef("");
        setYourRef("");
        setSelectFromAll([]);
        setSelectToAll([]); 
        GetAccountsAPI();
        setPdfDownload(false);       
      }

      const callToPDF = () =>{
        setConfirmReview(false);
        setPdfDownload(true)
      }
      var C_Name = JSON.parse(sessionStorage.getItem("NIC"));
        if(ShowReview){
            return ( <div>{ReviewModal()}</div> );
        }else if(SuccessLoading){
          return ( <div>{ResponseLoadingModal()}</div> );
        }else if(ConfirmReview){
          return(
            <SuccessMSG ConfirmSuccess={ConfirmReview} onHide={()=>setConfirmReview(false)} 
            Close={callToPDF} head="TRANSFER" head2="SUCCESS" 
            contentline1="Your Transaction is successful"/>
          )
        }else if(PdfDownload){
          return(
            <DownloadPDF show={PdfDownload} onHide={resetForm} 
            senderAccount={SelectFromAccount}  paydate={moment(toDate).format('DD/MM/YYYY')}
            senderName={C_Name.title+" "+C_Name.UserFirstname+" "+C_Name.UserLastname}
            time={moment(toDate).format('HH:mm:ss')}
            beneName={C_Name.title+" "+C_Name.UserFirstname+" "+C_Name.UserLastname}
            refNum={TransActionRef} bank={"Senkadagala Finance"}  branch={"Colombo"}
            beneAccount={SelectToAccount} amount={EnteredAmount} 
            bankRef={BeneRef} type={"Own Account Transfer"} scheduled={showCalender? moment(SelectDate).format('DD/MM/YYYY')
            :moment(new Date()).format('DD/MM/YYYY')}           
            >
            <div className='d-flex flex-row s-top'>
              <p className=' form-h2 t-width1'>Date</p>
              <p className='t-width2 form-h2'>
              {showCalender? moment(SelectDate).format('DD/MM/YYYY')
              :moment(new Date()).format('DD/MM/YYYY')}
            </p>
            </div>
            </DownloadPDF>
          )
        }else{
          return (
              <div>
                  
              <Modal
                show={props.isOpen}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered 
                backdrop="static"
                onHide={props.toggle}
              >
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title-vcenter">
                    <p className='modal-head-f'>OWN ACCOUNT</p><br/>TRANSFERS
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  
                  <Form  id='Form1'  >
                      <Form.Group as={Row} className="mb-1">
                          <Form.Label className="c-font" column sm={4}>
                              From
                          </Form.Label>
                          <Col sm={8}>
                          <Form.Select 
                          size="sm"                         
                          className="form-h2"
                          value={JSON.stringify(SelectFromAll)}
                          onChange={SelectFromOnChange}
                          >
                              <option value={JSON.stringify("select")}>Select</option>
                              {FromAccountList?FromAccountList.filter((e)=>e.jointAccountVisibility==true).map((listValue,index)=>{
                                 return (
                                 <option  key={index} value={JSON.stringify(listValue)}>
                                   A / N : {listValue.accountNo} | Balance : LKR {parseFloat(listValue.avialableBalance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                  </option>)
                              }):
                              null
                              }
                              
                          </Form.Select>
                          <p className='vali-txt'>{validator.message('Account', SelectFromAccount, 'required')}</p>
                          </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-1 margintop-f" >
                          <Form.Label className="c-font" column sm={4}>
                              To
                          </Form.Label>
                          <Col sm={8}>
                          <Form.Select size="sm"
                           className="form-h2 "
                           value={JSON.stringify(SelectToAll)}
                           onChange={SelectToOnChange}>
                              <option value={JSON.stringify("select")}>Select</option>
                              {ToAccountList?ToAccountList.filter((e)=>e.accountNo!=SelectFromAccount).map((listValue,index)=>{
                                 return (
                                 <option  key={index} value={JSON.stringify(listValue)}>
                                   A / N : {listValue.accountNo} | Balance : LKR {parseFloat(listValue.avialableBalance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                  </option>)
                              }):
                              null
                              }                            
                          </Form.Select>
                          <p className='vali-txt'>{validator.message('Account', SelectToAccount, 'required')}</p>
                          </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-1 margintop-f">
                          <Form.Label className="c-font" column sm={4}>
                              Amount
                          </Form.Label>
                          <Col sm={8} >
                          <Form.Control 
                          className="form-h2" 
                          size="sm" 
                          value={EnteredAmount}
                          type="number" placeholder="Amount"
                          onChange={(text)=>setEnteredAmount(text.target.value)}
                           />
                           <p className='vali-txt'>{validator.message('Amount', EnteredAmount, 'required')}</p>
                          </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-1 margintop-f">
                          <Form.Label className="c-font" column sm={4}>
                           Your Reference
                          </Form.Label>
                          <Col sm={8} >
                          <Form.Control 
                          className="form-h2"
                           size="sm" type="text" 
                           onBlur = {()=>{setBeneRef(YourRef)}}
                           value={YourRef}
                           placeholder="Your Reference"
                           onChange={(text)=>setYourRef(text.target.value)} />
                          </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-1">
                          <Form.Label className="c-font" column sm={4}>
                           Beneficiary Reference
                          </Form.Label>
                          <Col sm={8} >
                          <Form.Control
                           className="form-h2"
                            size="sm"
                            value={BeneRef}
                             type="text" placeholder="Beneficiary Reference" 
                             onChange={(text)=>setBeneRef(text.target.value)} />
                          </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-1">
                          <Form.Label className="c-font" column sm={4}>
                           Payment Date
                          </Form.Label>
                          <Col sm={8} >                        
                              <div>
                                  <input checked={!showCalender} onChange={()=>{setCalender(false)}} type="radio" id="html" name="fav_language" value="HTML"/>
                                  <label className='lable c-font' > Now</label>
                              </div>
                              <div className='d-flex flex-row align-items-center'>
                                  <input checked={showCalender} onChange={()=>{setCalender(true)}} type="radio" id="css" name="fav_language" value="CSS"/>
                                  <label className='lable c-font' > Scheduled</label> 
                                  {showCalender?<DatePicker
                                    className="datepicker"
                                    selected={SelectDate}
                                    onChange={(OnDate)=>setSelectDate(OnDate)}
                                    dateFormat="dd/MM/yyyy"
                                    minDate={new Date()}
                                    
                                />:null}
                              </div>                  
                          </Col>
                      </Form.Group>
                      <p className='vali-txt'>{ErrorMsg}</p>
                  </Form>
                </Modal.Body>
                <Modal.Footer className="mb-1 margintop-f2">                
                  <Button className="btn-logout" onClick={()=> ValidateFields()}>Process Transfer</Button>
                </Modal.Footer>
              </Modal>
              </div>
            );
          }
    }

export default OwnTransfer;